export interface StatusItem {
  text: string;
  /** inverted: the only emphasis the house style allows (offline, needs sign-in) */
  alert?: boolean;
}

/** One mono line of sync state: "// live · 3 pending · synced 14:02". */
export function StatusLine({ items, testId }: { items: StatusItem[]; testId?: string }) {
  return (
    <p className="status-line m" role="status" aria-live="polite" data-testid={testId}>
      {items.map((it, i) => (
        <span key={i}>
          {i > 0 ? <span className="sep"> · </span> : null}
          <span className={it.alert ? "invert flag" : undefined}>{it.text}</span>
        </span>
      ))}
    </p>
  );
}
